import { dispatch } from '@ngxs/store';
import { LocalActions } from './local.actions';
import * as i0 from "@angular/core";
export let LocalFacade = /*#__PURE__*/(() => {
  class LocalFacade {
    constructor() {
      this.set = dispatch(LocalActions.Set);
    }
    static {
      this.ɵfac = function LocalFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocalFacade)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: LocalFacade,
        factory: LocalFacade.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LocalFacade;
})();